import React, { useState, useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import HistoryIcon from '@mui/icons-material/History';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';

import Context from "../context";
import { handleRecallVisit, markDisputeResolved } from "../service";

const DisputeActions = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const context = useContext(Context);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton 
                onClick={handleClick}
                size="small"
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}>
                <MoreVertIcon />
            </IconButton>

            <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <MenuItem 
                    onClick={() => {
                        markDisputeResolved(context.dispute, context.dispatch);
                    }}
                >
                    <ListItemIcon>
                        <HandshakeRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Mark as resolved
                </MenuItem>
                <MenuItem 
                    onClick={() => {
                        handleRecallVisit(context.dispute, context.dispatch);
                    }}
                >
                    <ListItemIcon>
                        <HistoryIcon fontSize="small" />
                    </ListItemIcon>
                    Recall visit
                </MenuItem>
            </Menu>
        </>
    );
}

export default DisputeActions;